import * as React from "react";
const EMPTY = [];
function useOnMount(fn) {
  React.useEffect(fn, EMPTY);
}
export {
  useOnMount
};
//# sourceMappingURL=useOnMount.es.js.map
